/* eslint-disable no-restricted-globals */
/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
/* eslint-disable arrow-parens */
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { getToken, removeToken } from '@/utils/auth';
import store from '../store';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000,
});

service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken();
  }
  config.headers['Accept'] = 'application/json';
  return config;
}, error => {
  Promise.reject(error);
});

service.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status == 401) {
      removeToken();
      window.location.href = '/';
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
